import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CommonRoute } from '../../../../common/enums/common-route.enum';
import { SupportAvailabilityService } from '../services/support-availability.service';

/**
 * Keeps the Support Inbox unreachable while the feature is switched off — a
 * bookmark or a restored tab reaches the URL directly, and every endpoint
 * behind it answers 404, so the screen would render and immediately fail.
 */
export const SupportEnabledGuard: CanActivateFn = async () => {
  const availability = inject(SupportAvailabilityService);
  const router = inject(Router);

  if (await availability.refresh()) {
    return true;
  }

  return router.createUrlTree([CommonRoute.NOT_FOUND]);
};
